<script lang="ts">
import { Route, useLocation } from "svelte-navigator";
import Layout from "./Components/Layout.svelte";
import LoginLayout from "./Components/LayoutLogin.svelte";
import HelpDesk from "./Components/HelpDesk.svelte";
import Tickets from "./Components/Tickets.svelte";
import { user } from "./store";
import * as config from './config.json'
import { getComponent } from './Components';
import Login from './Components/Login.svelte';
import ForgotPassword from './Components/ForgotPassword.svelte';
import SetPassword from './Components/SetPassword.svelte';
import SiteCountdown from './Components/SiteCountdown.svelte';
import { minuteOnMinuteInterval } from "./util";

const location = useLocation();

(<any>window).config = config;

let sections = config.sections.filter(s => s.component !== 'tickets');
let firstSection;
let firstSectionProps;
let framed;
let open;
$: {
  firstSection = Object.values(config.sections)[0]
  const {path, component, ...props} = firstSection;
  firstSectionProps = props;
}
$: document.title = config.title;
$: document.body.style.fontFamily = `${config.font.name},-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif`;
$: {
  const activeComponent = $location.pathname === '/' ? 
    firstSection.component :
    config.sections.find(s => `/${s.path}` === $location.pathname)?.component;

  framed = !activeComponent || !['floor'].includes(activeComponent);
}

// $: if (!$user && config.sections.some(s => `/${s.path}` === $location.pathname)) {
//   localStorage.setItem('redir', window.location.href)
//   window.location.href = '/';
// }

function getSection(componentName) {
  return config.sections.some(s => s.component === componentName);
}

function getComponentProps(componentName) {
  const section = config.sections.find(s => s.component === componentName);
  if (!section) return {};
  const {component, path, ...props} = section;
  return props;
}

const hasTicketSection = getSection('tickets');

const isOpen = () => !config.liveDateTime || new Date(config.liveDateTime) <= new Date();
open = isOpen();
if (!open) {
  let sub = minuteOnMinuteInterval().subscribe(_ => {
    open = isOpen();
    if (open) sub.unsubscribe();
  });
}
</script>

<svelte:head>
  <link rel="stylesheet" href={config.font.href}>
  <link rel="icon" type="image/png" href={config.favicon} />
</svelte:head>

{#if hasTicketSection}
  <Route path="tickets" component={Tickets} {...getComponentProps('tickets')} />
{/if}

{#if $location.pathname !== '/tickets'}
  {#if $user}
    {#if !open}
      <LoginLayout title={config.title} privacyUrl={config.privacyUrl} termsUrl={config.termsUrl} logo={config.logo} background={config.login.background}>
        <Route path="help" component={HelpDesk} />
        <Route path="*" component={SiteCountdown} />
      </LoginLayout>
    {:else}
      <Layout frame={framed} title={config.title} sections={config.sections} logo={config.logo} background={config.background} termsUrl={config.termsUrl}>
        {#each sections as section(section.path)}
          <Route path={section.path} {...section} component={getComponent(section.component)} />
        {/each}
        <Route path="help" component={HelpDesk} />
        <Route path="*" component={getComponent(firstSection.component)} {...firstSectionProps} />
      </Layout>
    {/if}
  {:else}
    <LoginLayout title={config.title} privacyUrl={config.privacyUrl} termsUrl={config.termsUrl} logo={config.logo} background={config.login.background}>
      <Route path="help" component={HelpDesk} />
      <Route path="forgot" component={ForgotPassword} />
      <Route path="set-password" component={SetPassword} />
      <Route path="*" component={Login} {...config.login} />
    </LoginLayout>
  {/if}
{/if}